var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111354",
    d: "M4.243 14.142l9.9-9.9 1.413 1.415-9.899 9.899z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#111354",
    d: "M14.142 15.557l-9.9-9.9 1.415-1.414 9.9 9.9z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iNC4yNDI2OCIgeT0iMTQuMTQyMiIgd2lkdGg9IjE0IiBoZWlnaHQ9IjIiIHRyYW5zZm9ybT0icm90YXRlKC00NSA0LjI0MjY4IDE0LjE0MjIpIiBmaWxsPSIjMTExMzU0Ii8+CjxyZWN0IHg9IjE0LjE0MjEiIHk9IjE1LjU1NjQiIHdpZHRoPSIxNCIgaGVpZ2h0PSIyIiB0cmFuc2Zvcm09InJvdGF0ZSgtMTM1IDE0LjE0MjEgMTUuNTU2NCkiIGZpbGw9IiMxMTEzNTQiLz4KPC9zdmc+Cgo=";
export { SvgCloseX as ReactComponent };